import gql from 'graphql-tag';

export const UPDATE_AD_SET_DAILY_SPEND_CAP_MODE_MUTATION = gql`
  mutation updateAdSetDailySpendCapModeMutation($id: ID!, $dailySpendCapMode: AdSetSpendModeEnum!) {
    updateAdSetDailySpendCapMode(id: $id, dailySpendCapMode: $dailySpendCapMode) {
      adSet {
        id
        dailySpendCapMode
        availableDailySpendCapModes
      }
      errors
    }
  }
`;
